import DocumentBirthListPage from 'civil-status/pages/document-birth-list';
import DocumentBirthSearchPage from 'civil-status/pages/document-birth-search/search';
import DocumentBirthSearchInitializerPage from 'civil-status/pages/document-birth-search';
import DocumentDeathListPage from 'civil-status/pages/document-death-list';
import DocumentDeathSearchInitializerPage from 'civil-status/pages/document-death-search';
import DocumentDeathSearchPage from 'civil-status/pages/document-death-search/search';
import DocumentMarriageListPage from 'civil-status/pages/document-marriage-list';
import DocumentMarriageSearchInitializerPage from 'civil-status/pages/document-marriage-search';
import DocumentMarriageSearchPage from 'civil-status/pages/document-marriage-search/search';
import DocumentRegistryDetailPage from 'civil-status/pages/document-registry/detail';
import DocumentRegistryEditPage from 'civil-status/pages/document-registry/edit';
import DocumentRegistryList from 'civil-status/pages/document-registry/list';
import DocumentRegistryNewPage from 'civil-status/pages/document-registry/new';
import DocumentSerieDetailPage from 'civil-status/pages/document-serie/detail';
import DocumentSerieEditPage from 'civil-status/pages/document-serie/edit';
import DocumentSerieList from 'civil-status/pages/document-serie/list';
import DocumentSerieNewPage from 'civil-status/pages/document-serie/new';
import HomePage from 'civil-status/pages/home';
import NotesTextDetailPage from 'civil-status/pages/notes-text/detail';
import NotesTextEditPage from 'civil-status/pages/notes-text/edit';
import NotesTextList from 'civil-status/pages/notes-text/list';
import NotesTextNewPage from 'civil-status/pages/notes-text/new';
// import PrintFormulaDetailPage from 'civil-status/pages/print-formula/detail';
// import PrintFormulaEditPage from 'civil-status/pages/print-formula/edit';
// import PrintFormulaList from 'civil-status/pages/print-formula/list';
// import PrintFormulaNewPage from 'civil-status/pages/print-formula/new';
import StampCertificateDetailPage from 'civil-status/pages/stamp-certificate/detail';
import StampCertificateEditPage from 'civil-status/pages/stamp-certificate/edit';
import StampCertificateList from 'civil-status/pages/stamp-certificate/list';
import StampCertificateNewPage from 'civil-status/pages/stamp-certificate/new';
import DocumentBirthUploadPage from 'civil-status/pages/upload-document-birth';
import DocumentDeathUploadPage from 'civil-status/pages/upload-document-death';
import DocumentMarriageUploadPage from 'civil-status/pages/upload-document-marriage';
import { Outlet } from 'react-router-dom';
import {
  CivilStatusBirthUpload,
  CivilStatusMarriageUpload,
  CivilStatusDeathUpload,
  CivilStatusBirthSearch,
  CivilStatusDeathSearch,
  CivilStatusMarriageSearch,
  // CivilStatusPrintFormula,
  CivilStatusStampCertificate,
  CivilStatusNotesText,
  CivilStatusDocumentRegistry,
  CivilStatusDocumentSerie,
  CivilStatusAuthorizations,
  CivilUnionList,
  CivilStatusUnionCivilUpload,
  CitizenshipList,
  AnscMunicipality,
  CivilStatusBirthplaces,
  AnscDomainManagement,
  AnscCommunication,
  AnscReport,
  AnscArchive,
  AnscPec,
  AnscResearchNotifications,
  AnscRegisterEmergency,
} from 'shell/authorizations/civil-status';
import { NotFound } from 'shell/error/components/error-not-found';
import DocumentBirthFormPage from 'civil-status/pages/document-birth-form';
import DocumentMarriageFormPage from 'civil-status/pages/document-marriage-form';
import DocumentDeathFormPage from 'civil-status/pages/document-death-form';
import PageDocumentCivilUnionSearchInitializer from 'civil-status/pages/document-civil-union-search';
import DocumentCivilUnionSearchPage from 'civil-status/pages/document-civil-union-search/search';
import DocumentCivilUnionFormPage from 'civil-status/pages/document-civil-union-form';
import DocumentCivilUnionListPage from 'civil-status/pages/document-civil-union-list';
import DocumentCivilUnionUpload from 'civil-status/pages/upload-document-civil-union';
import DocumentCitizenshipSearchPage from 'civil-status/pages/document-citizenship-search/search';
import DocumentCitizenshipFormPage from 'civil-status/pages/document-citizenship-form';
import PageDocumentCitizenshipSearchInitializer from 'civil-status/pages/document-citizenship-search';
import DocumentCitizenshipListPage from 'civil-status/pages/document-citizenship-list';
import DocumentCitizenshipUploadPage from 'civil-status/pages/upload-document-citizenship';
import SimaPage from 'civil-status/pages/sima';
import SubMenuPage from 'civil-status/pages/home/sub-menu-page';
import SubMenuPagePost from 'civil-status/pages/home/sub-menu-page/sub-menu-page-post';
import StepPage from 'civil-status/pages/step';
import ActResearchPage from 'civil-status/pages/research/list';
import ActResearchCatPage from 'civil-status/pages/research-category/list';
import StepFromAnsc from 'civil-status/pages/step-from-ansc';
import CertificationFormPage from 'shell/components/shared/certification-civil-status';
import ActDomainManagementPage from 'civil-status/pages/act-domain-management/list';
import ActNewDomainManagementPage from 'civil-status/pages/act-domain-management/new';
import PageDomainManagementInitializer from 'civil-status/pages/act-domain-management';
import DocumentBirthUploadNewPage from 'civil-status/pages/upload-document-birth/new';
import DocumentMarriageUploadNewPage from 'civil-status/pages/upload-document-marriage/new';
import DocumentDeathUploadNewPage from 'civil-status/pages/upload-document-death/new';
import DocumentCivilUnionUploadNewPage from 'civil-status/pages/upload-document-civil-union/new';
import DocumentCitizenshipUploadNewPage from 'civil-status/pages/upload-document-citizenship/new';
import ResearchMunicipality from 'civil-status/pages/research-municipality';
import Municipality from 'civil-status/pages/municipality';
import BirthplaceListPage from 'civil-status/pages/birthplace/list';
import BirthplaceNewPage from 'civil-status/pages/birthplace/new';
import BirthplaceEditPage from 'civil-status/pages/birthplace/edit';
import BirthplaceDetailPage from 'civil-status/pages/birthplace/detail';
import ActDomainDetailManagementPage from 'civil-status/pages/act-domain-management/detail';
import ActEditDomainManagementPage from 'civil-status/pages/act-domain-management/edit';
import BirthplaceInitializer from 'civil-status/pages/birthplace';
import ResearchMunicipalityInitializer from 'civil-status/pages/research-municipality/municipalityInitializer';
import ActResearchIcaroPage from 'civil-status/pages/research-icaro';
import IcaroDetailPage from 'civil-status/pages/icaro-detail';
import RequestMunicipalNumberPage from 'civil-status/pages/request-municipal-number';
import ResearchMunicipalNumberPage from 'civil-status/pages/research-municipal-number';
import DeathplaceListPage from 'civil-status/pages/deathplace/list';
import DeathplaceInitializer from 'civil-status/pages/deathplace';
import DeathplaceDetailPage from 'civil-status/pages/deathplace/detail';
import DeathplaceEditPage from 'civil-status/pages/deathplace/edit';
import DeathplaceNewPage from 'civil-status/pages/deathplace/new';
import DeathAuthorityInitializer from 'civil-status/pages/death-authority';
import DeathAuthorityListPage from 'civil-status/pages/death-authority/list';
import DeathAutorityDetailPage from 'civil-status/pages/death-authority/detail';
import DeathAutorityEditPage from 'civil-status/pages/death-authority/edit';
import DeathAutorityNewPage from 'civil-status/pages/death-authority/new';
import ResearchNotificationsPage from 'civil-status/pages/research-notifications/list';
import ReligiousCultsInitializer from 'civil-status/pages/religious-cults';
import ReligiousCultsDetailPage from 'civil-status/pages/religious-cults/detail';
import ReligiousCultsListPage from 'civil-status/pages/religious-cults/list';
import ReligiousCultsEditPage from 'civil-status/pages/religious-cults/edit';
import ReligiousCultsNewPage from 'civil-status/pages/religious-cults/new';
import MinisterReligionInitializer from 'civil-status/pages/minister-religion';
import MinisterReligionListPage from 'civil-status/pages/minister-religion/list';
import MinisterReligionDetailPage from 'civil-status/pages/minister-religion/detail';
import MinisterReligionEditPage from 'civil-status/pages/minister-religion/edit';
import MinisterReligionNewPage from 'civil-status/pages/minister-religion/new';
import ResearchReportPage from 'civil-status/pages/research-report';
import ManagementPecPage from 'civil-status/pages/management-pec/list';
import PageActResearchCatInitizializer from 'civil-status/pages/research-category';
import PageResearchNotificationsInitizializer from 'civil-status/pages/research-notifications';
import PageActResearchInitizializer from 'civil-status/pages/research';
import PecDetailPage from 'civil-status/pages/management-pec/detail';
import ManagementPecPageSearchInitializer from 'civil-status/pages/management-pec';
import PecEditPage from 'civil-status/pages/management-pec/edit';
import ArchiveAnnotationsInitializer from 'civil-status/pages/archive-annotations';
import ArchiveAnnotationsPage from 'civil-status/pages/archive-annotations/list';
import PageNotificationsInitizializer from 'shell/components/shared/research-notifications';
import ResearchFamilyNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/family';
import ResearchFamilyNotificationsDetailPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/family/detail';
import ResearchFamilyNotificationsMotherPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/mother';
import ResearchFamilyNotificationsMotherDetailPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/mother/detail';
import ResearchFamilyNotificationsFatherPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/father';
import ResearchFamilyNotificationsFatherDetailPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/father/detail';
import ResearchFamilyNotificationsOtherPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/other';
import ResearchFamilyNotificationsOtherDetailPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-family/other/detail';
import ResearchCohabitationNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-cohabitation';
import ResearchCohabitationNotificationsDetailPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-cohabitation/detail';
import ResearchDeathNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-death';
import CancellationDeathNotificationPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-death/detail';
import ResearchMarriageNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage';
import ResearchMarriageDetailNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage/detail';
import ResearchCitizenshipNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-citizenship';
import RegistrationCitizenshipNotificationPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-citizenship/detail';
import ResearchMarriageNonResidentNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage-non-resident';
import ResearchMarriageNonResidentDetailNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person';
import PersonSearchMarriageNonResidentNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person-search';
import ResearchDeathNonResidentNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-death-non-resident';
import ResearchDeathNonResidentDetailNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-death-non-resident/detail';
import PersonSearchDeathNonResidentNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-death-non-resident/edit-person-search';
import PageResearchCommunicationFormListInitizializer from 'civil-status/pages/research-communication-form-list';
import PageResearchCommunicationFormList from 'civil-status/pages/research-communication-form-list/list';
import ResearchNotificationsSidePage from 'civil-status/pages/research-notifications-side/list';
import PageResearchNotificationsSideInitizializer from 'civil-status/pages/research-notifications-side';
import PageResearchNotificationsAnscOperatorInitizializer from 'civil-status/pages/research-notifications-ansc-operator';
import ResearchNotificationsAnscOperatorPage from 'civil-status/pages/research-notifications-ansc-operator/list';
import ResearchNotificationsCivilStatusRegistryOfficePage from 'civil-status/pages/research-registration-civil-status-registry-office/list';
import DetailNotificationsCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/detail';
import EditNotificationsCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/edit';
import ResearchBirthNonResidentNotificationsCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/reasearch-birth-non-resident';
import ResearchCivilUnionNotificationCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union';
import RegistrationCivilUnionDetailNotificationsPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union/detail';
import ResearchCivilUnionNonResidentNotificationCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentNotificationCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionDetailNotificationsCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentNotificationCivilStatusPage from 'civil-status/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person';
import PageDetailNotificationsAnscOperator from 'civil-status/pages/research-notifications-ansc-operator/detail';
import PageActResearchEmergencyInitizializer from 'civil-status/pages/research';
import ActResearchEmergencyPage from 'civil-status/pages/research-emergency/list';
import StepEmergencyPage from 'civil-status/pages/step-from-emergency';

export const civilStatusRoutes = [
  {
    path: '',
    name: 'Stato Civile',
    element: <Outlet />,
    children: [
      {
        name: 'Stato Civile',
        element: <HomePage />,
        path: '/',
        hidden: true,
      },
      {
        path: '/SIMA',
        name: 'SIMA',
        children: [
          {
            path: '',
            element: <SimaPage />,
          },
        ],
      },
      {
        path: '/gestione-pec',
        element: <ManagementPecPageSearchInitializer />,
        name: 'Gestione PEC',
        authorizations: AnscPec,
        children: [
          {
            path: '',
            element: <ManagementPecPage />,
          },
          {
            path: '/dettaglio/:id',
            element: <PecDetailPage />,
          },
          {
            path: '/modifica/:id',
            element: <PecEditPage />,
          },
        ],
      },
      {
        path: '/annotazioni-archivio',
        element: <ArchiveAnnotationsInitializer />,
        name: 'Annotazioni archivio',
        authorizations: AnscArchive,
        children: [
          {
            path: '',
            element: <ArchiveAnnotationsPage />,
          },
        ],
      },
      {
        path: '/ricerca-atto-da-compilare',
        element: <PageActResearchInitizializer />,
        name: 'Ricerca atto da completare',
        children: [
          {
            path: '',
            element: <ActResearchPage />,
          },
          {
            path: '/modifica/:idEvento',
            element: <StepPage isEdit />,
          },
          {
            path: '/visualizza/:idEvento',
            element: <StepPage isDetail />,
          },
        ],
      },
      {
        path: '/recupero-atti-emergenza',
        element: <PageActResearchEmergencyInitizializer />,
        name: 'Recupero Atti Registro di emergenza',
        authorizations: AnscRegisterEmergency,
        children: [
          {
            path: '',
            element: <ActResearchEmergencyPage />,
          },
          {
            path: '/modifica/:idEvento',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <StepEmergencyPage />,
              },
              {
                path: '/confermato',
                element: <StepPage isStepFromEmergencyConfirm />,
              },
            ],
          },
        ],
      },
      {
        path: '/:valueCat/:idCat/ricerca-icaro',
        name: 'Ricerca Icaro',
        children: [
          {
            path: '',
            element: <ActResearchIcaroPage />,
          },
          {
            path: '/visualizza/:contatore',
            element: <IcaroDetailPage />,
          },
          {
            path: '/rifiuta/:contatore',
            element: <IcaroDetailPage isRejection />,
          },
        ],
      },
      {
        path: '/:valueCat/:idCat/richiesta-numero',
        name: 'Richiesta numero comunale',
        children: [
          {
            path: '',
            element: <RequestMunicipalNumberPage />,
          },
        ],
      },
      {
        path: '/:valueCat/:idCat/ricerca-numero',
        name: 'Ricerca numero comunale',
        children: [
          {
            path: '',
            element: <ResearchMunicipalNumberPage />,
          },
        ],
      },
      {
        path: '/ricerca-comune',
        name: 'Ricerca Comune',
        element: <ResearchMunicipalityInitializer />,
        authorizations: AnscMunicipality,
        children: [
          {
            path: '',
            element: <ResearchMunicipality />,
          },
          {
            path: '/nuovo',
            element: <Municipality />,
          },
          {
            path: '/modifica/:idValore',
            element: <Municipality isEdit />,
          },
          {
            path: '/visualizza/:idValore',
            element: <Municipality isDeatil />,
          },
        ],
      },
      {
        path: '/:valueCat/:idCat/ricerca',
        element: <PageActResearchCatInitizializer />,
        name: 'Ricerca categoria',
        children: [
          {
            path: '',
            element: <ActResearchCatPage />,
          },
          {
            path: '/visualizza/:id',
            element: <StepFromAnsc />,
          },
          {
            path: '/visualizza/:id/persona',
            element: <StepFromAnsc isResearchPerson />,
          },
        ],
      },
      {
        path: '/ricerca-atti',
        element: <PageActResearchCatInitizializer />,
        name: 'Ricerca Atti',
        children: [
          {
            path: '',
            element: <ActResearchCatPage />,
          },
          {
            path: '/visualizza/:id',
            element: <StepFromAnsc />,
          },
          {
            path: '/visualizza/:id/persona',
            element: <StepFromAnsc isResearchPerson />,
          },
          {
            path: '/visualizza/:id/:idEvento',
            element: <StepPage isTranscribeOathFromAnsc />,
          },
        ],
      },
      {
        path: '/ricerca-comunicazioni-da-lista/:valueCat/:idCat',
        element: <PageResearchCommunicationFormListInitizializer />,
        name: 'Comunicazioni da Lista',
        authorizations: AnscCommunication,
        children: [
          {
            path: '',
            element: <PageResearchCommunicationFormList />,
          },
          // {
          //   path: '/visualizza/:id',
          //   element: <StepFromAnsc isCommunications />,
          // },
          // {
          //   path: '/visualizza/:id/persona',
          //   element: <StepFromAnsc isResearchPerson isCommunications />,
          // },
        ],
      },
      {
        path: '/ricerca-comunicazioni/:valueCat/:idCat',
        element: <PageActResearchCatInitizializer />,
        name: 'Comunicazioni',
        authorizations: AnscCommunication,
        children: [
          {
            path: '',
            element: <ActResearchCatPage isCommunications />,
          },
          {
            path: '/visualizza/:id',
            element: <StepFromAnsc isCommunications />,
          },
          {
            path: '/visualizza/:id/persona',
            element: <StepFromAnsc isResearchPerson isCommunications />,
          },
        ],
      },
      {
        path: '/ricerca-reportistica/:valueCat/:idCat',
        name: 'Reportistica',
        authorizations: AnscReport,
        children: [
          {
            path: '',
            element: <ResearchReportPage />,
          },
        ],
      },
      // {
      //   path: '/notifiche',
      //   element: <PageResearchNotificationsInitizializer />,
      //   name: 'Ricerca Notifiche',
      //   children: [
      //     {
      //       path: '/ansc',
      //       element: <Outlet />,
      //       children: [
      //         {
      //           path: '/ricerca',
      //           element: <Outlet />,
      //           children: [
      //             {
      //               path: '',
      //               element: <ResearchNotificationsPage />,
      //             },
      //             {
      //               path: '/visualizza/:id/:idNotification/:stateNotification',
      //               element: <StepFromAnsc isNotifications />,
      //             },
      //           ],
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   path: '/ricerca-notifiche/:valueCat/:idCat',
      //   element: <PageResearchNotificationsInitizializer />,
      //   name: 'Ricerca Notifiche',
      //   children: [
      //     {
      //       path: '',
      //       element: <ResearchNotificationsPage />,
      //     },
      //     {
      //       path: '/visualizza/:id/:idNotification/:stateNotification',
      //       element: <StepFromAnsc isNotifications />,
      //     },
      //   ],
      // },
      {
        path: '/notifiche',
        element: <PageResearchNotificationsInitizializer />,
        authorizations: AnscResearchNotifications,
        children: [
          {
            path: '/ansc',
            elemnt: <Outlet />,
            children: [
              {
                path: '/ricerca',
                element: <Outlet />,
                name: 'Ricerca Notifiche',
                children: [
                  {
                    path: '',
                    element: <ResearchNotificationsPage />,
                  },
                  {
                    path: '/visualizza/:id/:idNotification/:stateNotification',
                    element: <StepFromAnsc isNotifications />,
                  },
                  {
                    path: '/operatore',
                    element: <PageResearchNotificationsAnscOperatorInitizializer />,
                    children: [
                      {
                        path: '',
                        element: <ResearchNotificationsAnscOperatorPage />,
                      },
                      {
                        path: '/visualizza/:id/:idNotification/:stateNotification',
                        element: <PageDetailNotificationsAnscOperator />,
                      },
                    ],
                  },
                  {
                    path: '/:valueCat/:idCat',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchNotificationsPage />,
                      },
                      {
                        path: '/visualizza/:id/:idNotification/:stateNotification',
                        element: <StepFromAnsc isNotifications />,
                      },
                      {
                        path: '/operatore',
                        element: <PageResearchNotificationsAnscOperatorInitizializer />,
                        children: [
                          {
                            path: '',
                            element: <ResearchNotificationsAnscOperatorPage />,
                          },
                          {
                            path: '/visualizza/:id/:idNotification/:stateNotification',
                            element: <StepFromAnsc isNotifications />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: '/side',
            element: <Outlet />,
            name: 'Ricerca Notifiche S.I.De.',
            children: [
              {
                path: '/ricerca',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <PageResearchNotificationsSideInitizializer />,
                    children: [
                      {
                        path: '',
                        element: <ResearchNotificationsSidePage />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/certificazione-ansc',
        name: 'Certificazione Stato Civile ANSC',
        authorizations: [CivilStatusAuthorizations.StampaCertificazione],
        children: [
          {
            path: '',
            element: <CertificationFormPage />,
          },
        ],
      },
      {
        path: '/:valueCat/:idCat/:sottoMenuName/:idEvento',
        children: [
          {
            path: '',
            element: <SubMenuPage />,
          },
          {
            path: '/:valuePostCat/:idPostCat',
            children: [
              {
                path: '',
                element: <SubMenuPagePost />,
              },
              {
                path: '/:valuePreStep/:idPreStep',
                element: <StepPage />,
              },
            ],
          },
        ],
      },
      {
        path: '/nascita/ricerca',
        name: 'Ricerca Atti Nascita',
        authorizations: CivilStatusBirthSearch,
        element: <DocumentBirthSearchInitializerPage />,
        children: [
          {
            path: '',
            element: <DocumentBirthSearchPage />,
          },
          {
            path: '/dettaglio/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1',
            element: <DocumentBirthFormPage />,
          },
        ],
      },
      {
        path: '/matrimonio/ricerca',
        name: 'Ricerca Atti Matrimonio',
        authorizations: CivilStatusMarriageSearch,
        element: <DocumentMarriageSearchInitializerPage />,
        children: [
          {
            path: '',
            element: <DocumentMarriageSearchPage />,
          },
          {
            path: '/dettaglio/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1',
            element: <DocumentMarriageFormPage />,
          },
        ],
      },
      {
        path: '/morte/ricerca',
        name: 'Ricerca Atti Morte',
        authorizations: CivilStatusDeathSearch,
        element: <DocumentDeathSearchInitializerPage />,
        children: [
          {
            path: '',
            element: <DocumentDeathSearchPage />,
          },
          {
            path: '/dettaglio/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1',
            element: <DocumentDeathFormPage />,
          },
        ],
      },
      {
        path: '/cittadinanza/ricerca',
        name: 'Ricerca Atti Cittadinanza',
        authorizations: CivilUnionList,
        element: <PageDocumentCitizenshipSearchInitializer />,
        children: [
          {
            path: '',
            element: <DocumentCitizenshipSearchPage />,
            authorizations: [CivilStatusAuthorizations.RicercaAttoUnioneCivile],
          },
          {
            path: '/dettaglio/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:nome/:cognome',
            element: <DocumentCitizenshipFormPage />,
            authorizations: [CivilStatusAuthorizations.RicercaAttoUnioneCivile],
          },
        ],
      },
      {
        path: '/unione-civile/ricerca',
        name: 'Ricerca Atti Unione Civile',
        authorizations: CivilUnionList,
        element: <PageDocumentCivilUnionSearchInitializer />,
        children: [
          {
            path: '',
            element: <DocumentCivilUnionSearchPage />,
            authorizations: [CivilStatusAuthorizations.RicercaAttoUnioneCivile],
          },
          {
            path: '/dettaglio/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1',
            element: <DocumentCivilUnionFormPage />,
            authorizations: [CivilStatusAuthorizations.RicercaAttoUnioneCivile],
          },
        ],
      },
      {
        path: '/nascita',
        name: 'Caricamento Atti Nascita',
        authorizations: CivilStatusBirthUpload,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentBirthListPage />,
          },
          {
            path: '/carica/nuovo',
            element: <DocumentBirthUploadNewPage />,
          },
          {
            path: '/carica/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:serie2',
            element: <DocumentBirthUploadPage />,
          },
        ],
      },
      {
        path: '/matrimonio',
        name: 'Caricamento Atti Matrimonio',
        authorizations: CivilStatusMarriageUpload,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentMarriageListPage />,
          },
          {
            path: '/carica/nuovo',
            element: <DocumentMarriageUploadNewPage />,
          },
          {
            path: '/carica/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:serie2',
            element: <DocumentMarriageUploadPage />,
          },
        ],
      },
      {
        path: '/morte',
        authorizations: CivilStatusDeathUpload,
        name: 'Caricamento Atti Morte',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentDeathListPage />,
          },
          {
            path: '/carica/nuovo',
            element: <DocumentDeathUploadNewPage />,
          },
          {
            path: '/carica/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:serie2',
            element: <DocumentDeathUploadPage />,
          },
        ],
      },

      {
        path: '/unione-civile',
        name: 'Caricamento Atti Unione Civile',
        authorizations: CivilStatusUnionCivilUpload,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentCivilUnionListPage />,
          },
          {
            path: '/carica/nuovo',
            element: <DocumentCivilUnionUploadNewPage />,
          },
          {
            path: '/carica/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:serie2',
            element: <DocumentCivilUnionUpload />,
          },
        ],
      },
      {
        path: '/cittadinanza',
        name: 'Caricamento Atti Cittadinanza',
        authorizations: CitizenshipList,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentCitizenshipListPage />,
          },
          {
            path: '/carica/nuovo',
            element: <DocumentCitizenshipUploadNewPage />,
          },
          {
            path: '/carica/:anno/:numeroRegistro/:numeroAtto/:parte/:serie1/:serie2/:nome/:cognome',
            element: <DocumentCitizenshipUploadPage />,
          },
        ],
      },
      // {
      //   path: '/formule',
      //   name: 'Formule di stampa',
      //   element: <Outlet />,
      //   authorizations: CivilStatusPrintFormula,
      //   children: [
      //     {
      //       path: '',
      //       element: <PrintFormulaList />,
      //     },
      //     {
      //       path: '/nuovo',
      //       element: <PrintFormulaNewPage />,
      //     },
      //     {
      //       path: '/modifica/:id',
      //       element: <PrintFormulaEditPage />,
      //     },
      //     {
      //       path: '/dettaglio/:id',
      //       element: <PrintFormulaDetailPage />,
      //     },
      //   ],
      // },
      {
        path: '/timbri',
        name: 'Timbri Certificato',
        authorizations: CivilStatusStampCertificate,
        element: <Outlet />,
        hidden: true,
        children: [
          {
            path: '',
            element: <StampCertificateList />,
          },
          {
            path: '/nuovo',
            element: <StampCertificateNewPage />,
            authorizations: [CivilStatusAuthorizations.TimbroCertificatoAdd],
          },
          {
            path: '/modifica/:id',
            element: <StampCertificateEditPage />,
            authorizations: [CivilStatusAuthorizations.TimbroCertificatoUpdate],
          },
          {
            path: '/dettaglio/:id',
            element: <StampCertificateDetailPage />,
            authorizations: [CivilStatusAuthorizations.TimbroCertificatoQuery],
          },
        ],
      },
      {
        path: '/annotazioni',
        name: 'Testo Annotazioni',
        hidden: true,
        authorizations: CivilStatusNotesText,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <NotesTextList />,
          },
          {
            path: '/nuovo',
            element: <NotesTextNewPage />,
            authorizations: [CivilStatusAuthorizations.AnnotazioneAdd],
          },
          {
            path: '/modifica/:id',
            element: <NotesTextEditPage />,
            authorizations: [CivilStatusAuthorizations.AnnotazioneUpdate],
          },
          {
            path: '/dettaglio/:id',
            element: <NotesTextDetailPage />,
            authorizations: [CivilStatusAuthorizations.AnnotazioneQuery],
          },
        ],
      },
      {
        path: '/registri',
        name: 'Registro Atto',
        hidden: true,
        authorizations: CivilStatusDocumentRegistry,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentRegistryList />,
          },
          {
            path: '/nuovo',
            element: <DocumentRegistryNewPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiRegistroAdd],
          },
          {
            path: '/modifica/:id',
            element: <DocumentRegistryEditPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiRegistroUpdate],
          },
          {
            path: '/dettaglio/:id',
            element: <DocumentRegistryDetailPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiRegistroQuery],
          },
        ],
      },
      {
        path: '/serie',
        name: 'Serie Atto',
        hidden: true,
        authorizations: CivilStatusDocumentSerie,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <DocumentSerieList />,
          },
          {
            path: '/nuovo',
            element: <DocumentSerieNewPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiSerieAdd],
          },
          {
            path: '/modifica/:id',
            element: <DocumentSerieEditPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiSerieUpdate],
          },
          {
            path: '/dettaglio/:id',
            element: <DocumentSerieDetailPage />,
            authorizations: [CivilStatusAuthorizations.DocumentiSerieQuery],
          },
        ],
      },
      {
        path: '/ricerca-dominio',
        element: <PageDomainManagementInitializer />,
        name: 'Gestione Domini',
        authorizations: AnscDomainManagement,
        children: [
          {
            path: '',
            element: <ActDomainManagementPage />,
          },
          {
            path: '/nuovo',
            element: <ActNewDomainManagementPage />,
            authorizations: [CivilStatusAuthorizations.AnscDominioInsert],
          },
          {
            path: '/dettaglio/:id',
            element: <ActDomainDetailManagementPage />,
            authorizations: [CivilStatusAuthorizations.AnscDominioQuery],
          },
          {
            path: '/modifica/:id',
            element: <ActEditDomainManagementPage />,
            authorizations: [CivilStatusAuthorizations.AnscDominioUpdate],
          },
        ],
      },
      {
        path: '/luogo-nascita',
        name: 'Ricerca luogo nascita',
        element: <BirthplaceInitializer />,
        authorizations: CivilStatusBirthplaces,
        children: [
          {
            path: '',
            element: <BirthplaceListPage />,
          },
          {
            path: '/nuovo',
            element: <BirthplaceNewPage />,
            authorizations: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
          },
          {
            path: '/modifica/:id',
            element: <BirthplaceEditPage />,
            authorizations: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
          },
          {
            path: '/dettaglio/:id',
            element: <BirthplaceDetailPage />,
            authorizations: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
          },
        ],
      },
      {
        path: '/luogo-decesso',
        name: 'Ricerca luogo decesso',
        element: <DeathplaceInitializer />,
        // authorizations: CivilStatusBirthplaces,
        children: [
          {
            path: '',
            element: <DeathplaceListPage />,
          },
          {
            path: '/dettaglio/:id',
            element: <DeathplaceDetailPage />,
            // authorizations: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
          },
          {
            path: '/modifica/:id',
            element: <DeathplaceEditPage />,
            // authorizations: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
          },
          {
            path: '/nuovo',
            element: <DeathplaceNewPage />,
            // authorizations: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
          },
        ],
      },
      {
        path: '/autorita-decesso',
        name: 'Ricerca autorità decesso',
        element: <DeathAuthorityInitializer />,
        // authorizations: CivilStatusBirthplaces,
        children: [
          {
            path: '',
            element: <DeathAuthorityListPage />,
          },
          {
            path: '/dettaglio/:id',
            element: <DeathAutorityDetailPage />,
            // authorizations: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
          },
          {
            path: '/modifica/:id',
            element: <DeathAutorityEditPage />,
            // authorizations: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
          },
          {
            path: '/nuovo',
            element: <DeathAutorityNewPage />,
            // authorizations: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
          },
        ],
      },
      {
        path: '/culti-religiosi',
        name: 'Ricerca culti religiosi',
        element: <ReligiousCultsInitializer />,
        // authorizations: CivilStatusBirthplaces,
        children: [
          {
            path: '',
            element: <ReligiousCultsListPage />,
          },
          {
            path: '/dettaglio/:id',
            element: <ReligiousCultsDetailPage />,
            // authorizations: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
          },
          {
            path: '/modifica/:id',
            element: <ReligiousCultsEditPage />,
            // authorizations: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
          },
          {
            path: '/nuovo',
            element: <ReligiousCultsNewPage />,
            // authorizations: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
          },
        ],
      },
      {
        path: '/ministro-culto',
        name: 'Ricerca ministro di culto',
        element: <MinisterReligionInitializer />,
        // authorizations: CivilStatusBirthplaces,
        children: [
          {
            path: '',
            element: <MinisterReligionListPage />,
          },
          {
            path: '/dettaglio/:id',
            element: <MinisterReligionDetailPage />,
            // authorizations: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
          },
          {
            path: '/modifica/:id',
            element: <MinisterReligionEditPage />,
            // authorizations: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
          },
          {
            path: '/nuovo',
            element: <MinisterReligionNewPage />,
            // authorizations: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
          },
        ],
      },
      {
        path: '/notifiche-da-stato-civile/:idCat',
        element: <PageNotificationsInitizializer />,
        children: [
          {
            path: '',
            element: <ResearchNotificationsCivilStatusRegistryOfficePage />,
          },
          {
            path: '/visualizza/:id/:idNotifica',
            element: <DetailNotificationsCivilStatusPage />,
          },
          {
            path: '/modifica/:id/:idNotifica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <EditNotificationsCivilStatusPage />,
              },
              {
                path: '/nascita',
                element: <Outlet />,
                children: [
                  {
                    path: '/non-residenti',
                    element: <ResearchBirthNonResidentNotificationsCivilStatusPage />,
                  },
                ],
              },
              {
                path: '/famiglia',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/madre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsMotherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsMotherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/padre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsFatherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsFatherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/altra',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsOtherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsOtherDetailPage />,
                  },
                ],
              },
              {
                path: '/convivenza',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchCohabitationNotificationsPage />,
                  },
                  {
                    path: '/nascita',
                    element: <ResearchCohabitationNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/morte',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNotificationsPage />,
                      },
                      {
                        path: '/cancellazione',
                        element: <CancellationDeathNotificationPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentDetailNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/cittadinanza/ricerca',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchCitizenshipNotificationsPage />,
                  },
                  {
                    path: '/registrazione',
                    element: <RegistrationCitizenshipNotificationPage />,
                  },
                ],
              },
              {
                path: '/matrimonio',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <ResearchMarriageDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentDetailNotificationsPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonMarriageNonResidentNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/unione-civile',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCivilUnionDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <RegistrationCivilUnionDetailNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonCivilUnionNonResidentNotificationCivilStatusPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
